module.exports = "<div class=modal-dialog ng-class=$ctrl.extraClasses role=document><div class=modal-content ng-transclude></div></div><div class=\"top-button hide\" ng-class=\"!$ctrl.isMobile ? 'desktop' : 'mobile'\" ng-click=$ctrl.scrollTop()></div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/modals/gmc-modal/gmc-modal.component.html
// module id = 885
// module chunks = 31